import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import Loader from 'common/components/Loader';
import NodeHeader from 'catalog/components/NodeHeader';

const mapStateToProps = (state, ownProps) => {
  const { catalog } = state;
  const node = ownProps.params.id
    ? catalog.nodes.find(n => n.id.toString() === ownProps.params.id.toString())
    : catalog.root;

  return {
    node,
    isLoading: catalog.isLoadingNode,
  };
};
class NodeLayout extends React.Component {
  static propTypes = {
    catalog: PropTypes.string.isRequired,
    node: PropTypes.object.isRequired,
    children: PropTypes.element.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };

  get content() {
    const { children, catalog, node } = this.props;
    return React.cloneElement(children, {
      catalog,
      node,
    });
  }

  render() {
    const { catalog, node, isLoading } = this.props;

    return (
      <div>
        <NodeHeader catalog={catalog} node={node} />
        <div className="ui clearing segment">
          <Loader visible={isLoading} text="Chargement en cours" />
          {this.content}
        </div>
      </div>
    );
  }
}

export default compose(connect(mapStateToProps), pure)(NodeLayout);



// WEBPACK FOOTER //
// ./src/modules/catalog/layouts/NodeLayout.js